import english from "./en";
import spanish from "./es";

const cv = {
  languages: {
    en: english,
    es: spanish,
  },
  options: {
    version: "1.4",
  },
};

export default cv;
